<template>
<div>
    <Sidebar/>
  <Navgator
    ref="navgator"
    :barraTitulo="' Administração - Usuários'"
    :titulo="'usuários'"
  />

  <!--Formulário de Cadastro -->
  <div class="card-container">
    <div class="card">
      <div class="row g-2 gy-4">
        <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Cadastrar Usuário</span>
          </div>
      </div>
      <form @submit.prevent="onSubmit">
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-6">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="empresa"
                required
              >
                <option
                  v-for="empresa in empresas"
                  :value="empresa.id"
                  :key="empresa.id"
                >
                  {{ empresa.nome }}
                </option>
              </select>
              <label>Empresa Principal</label>
            </div>
          </div>

          <div class="col-12 col-sm-2 col-md-3 col-lg-6 col-xl-6">
             <div class="d-md-none">
               <div class="form-floating txt-form-label">
                <div class="icon-toggle-wrapper">
                  <input
                    type="checkbox"
                    v-model="hab_empresa"
                    id="flexSwitchCheckDefault"
                    hidden
                  />
                      <label for="flexSwitchCheckDefault" class="icon-toggle-btn">
                    <i
                      class="bi"
                      title="Habilitar Empresas"
                      :class="
                       hab_empresa
                          ? 'bi bi-toggles text-white'
                          : 'bi bi-toggles'
                      "
                    ></i>
                  </label>

                </div>
              </div>
             </div>
             <div class="d-none d-md-block">
               <div class="form-floating txt-form-label">
              <div class="form-check form-switch txt-form-input">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="hab_empresa"
                />
                <label for="flexSwitchCheckDefault"
                  >Habilitar Empresas</label
                >
              </div>
            </div>
             </div>

          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="row g-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="username"
                    required
                  />
                  <label >Nome</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="email"
                    class="form-control txt-form-input"
                    v-model="email"
                    required
                    v-on:blur="validateEmail(email)"
                  />
                  <label>Email</label>
                </div>
              </div>
            </div>
            <div class="row g-2 mt-3">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="password"
                    class="form-control txt-form-input"
                    v-model="password"
                    required
                  />
                  <label>Senha</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="password"
                    class="form-control txt-form-input"
                    v-model="confirmPassword"
                    v-on:blur="checar_senha"
                    required
                  />
                  <label>Confirmar Senha</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
            <div class="row g-2">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating ">
                  <select
                    class="form-select txt-form-input"
                    size="5"
                    style="height: 8.7rem !important"
                    multiple
                    :disabled="hab_empresa"
                    v-model="empresa_arr"
                  >
                    <option
                      v-for="empresa in empresas"
                      :value="empresa.id"
                      :key="empresa.id"
                    >
                      {{ empresa.nome }}
                    </option>
                  </select>
                  <label class="txt-form-label">Empresas</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <div class="form-floating">
                  <select
                    class="form-select txt-form-input"
                    size="5"
                    style="height: 8.7rem !important"
                    multiple
                    v-model="funcao"
                    required
                  >
                    <option
                      v-for="funcao in funcoes"
                      :value="funcao.id"
                      :key="funcao.id"
                      @click="abrirModal(funcao)"
                    >
                      {{ funcao.nome }}
                    </option>
                  </select>
                  <label class="txt-form-label">Funções</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
              <!-- Botões de Ação - Mobile (apenas ícones) -->
              <div class="d-flex d-md-none gap-2">
                 <button
                  type="submit"
                  class="btn round-btn d-flex align-items-center justify-content-center"
                  >
                  <i class="bi bi-plus-circle" title="Inserir Usuário"></i>
                </button>
              </div>
              <!-- Botões de Ação - Tablet (768px - 991px) -->
              <div class="d-none d-md-flex d-lg-none gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap;"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
              <!-- Botões de Ação - Desktop (≥ 992px) -->
              <div class="d-none d-lg-flex gap-2">
                <button
                  type="submit"
                  class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                  style="font-size: 0.875rem; white-space: nowrap;"
                >
                  <span>Cadastrar</span>
                </button>
              </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div v-if="modalAberto">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                id="valid_funcao"
                v-model="tipo_vendedor"
                required
              >
                <option value="1">Novo</option>
                <option value="2">Usado</option>
                <option value="3">Ambos</option>
              </select>
              <label>Tipo Vendedor</label>
            </div>
          </div>
        </div>

      </form>
      <div v-if="abrir_modal">
        <Message :msg="msg" v-show="msg" />
      </div>
    </div>
  </div>

  <!--Bloco do Filtro-->
  <div class="card-container">
    <div class="card">
      <div class="row g-2 p-2">
        <div class="card-title gy-4">
          <i class="bi bi-funnel fs-5 icon-text-form"></i>
          <span class="txt-title-form">Filtro</span>
        </div>
      </div>
      <div class="row g-2 p-2">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div class="form-floating txt-form-label">
            <input
              type="text"
              class="form-control txt-form-input"
              v-model="searchTitle"
            />
            <label>Descrição</label>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div class="form-floating txt-form-label">
            <input
              type="text"
              class="form-control txt-form-input"
              v-model="searchEmail"
            />
            <label>Email</label>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div class="form-floating txt-form-label">
            <select
              class="form-select txt-form-input"
              v-model="searchStatus"
            >
              <option value="">------</option>
              <option value="0">Desabilitado</option>
              <option value="1">Habilitado</option>
            </select>
            <label>Status</label>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div class="form-floating txt-form-label">
            <select
              class="form-select txt-form-input"
              v-model="pageSize"
              @change="handlePageSizeChange(pageSize)"
            >
              <option v-for="size in pageSizes" :key="size" :value="size">
                {{ size }}
              </option>
            </select>
            <label >Itens Pág.</label>
          </div>
        </div>
        <!-- Seção: Ações -->
        <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
                 <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveUsuario();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
               <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap;"
                type="button"
                @click="
                  page = 1;
                  retrieveUsuario();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
               <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap;"
                type="button"
                @click="
                  page = 1;
                  retrieveUsuario();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!--Tabelas-->
  <div class="card-container">
    <div class="card ">
      <div class="d-md-none">
        <!-- Indicador de Carregamento -->
        <div v-if="isLoading" class="text-center my-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
        <div v-else>
            <div v-for="item in usuarios" :key="item.id" class="accordion mb-2">
          <div class="accordion-item">
            <button
              class="accordion-button collapsed card-table-txt"
              data-bs-toggle="collapse"
              :data-bs-target="'#row-' + item.id"
            >
              {{ item.nome }}
            </button>
            <div :id="'row-' + item.id" class="accordion-collapse collapse">
              <div class="accordion-body">
                <p class="card-table-item">
                  <strong>Email:</strong>
                  {{ item.email }}
                </p>
                <p class="card-table-item">
                  <strong>Empresas:</strong>
                  <ul class="scrollable-list">
                    <li v-for="empresa in item.empresa" :key="empresa.id">
                      {{ empresa.nome }}
                    </li>
                  </ul>
                </p>
                <p class="card-table-item">
                  <strong>Funções:</strong>
                  <ul class="scrollable-list">
                    <li v-for="funcao in item.funcao" :key="funcao.id">
                      {{ funcao.nome }}
                    </li>
                  </ul>
                </p>
                <p class="card-table-item">
                  <strong>Status:</strong>
                  {{ item.status }}
                </p>

                <button
                  type="button"
                  class="btn round-btn align-self-end"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="editar_usuario(item)"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="d-none d-md-block d-lg-none">
         <!-- Indicador de Carregamento -->
        <div v-if="isLoading" class="text-center my-4">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
        <div v-else>
            <div v-for="item in usuarios" :key="item.id" class="accordion mb-2">
          <div class="accordion-item">
            <button
              class="accordion-button collapsed card-table-txt"
              data-bs-toggle="collapse"
              :data-bs-target="'#row-' + item.id"
            >
              {{ item.nome }}
            </button>
            <div :id="'row-' + item.id" class="accordion-collapse collapse">
              <div class="accordion-body">
                <p class="card-table-item">
                  <strong>Email:</strong>
                  {{ item.email }}
                </p>
                <p class="card-table-item">
                  <strong>Empresas:</strong>
                  <ul class="scrollable-list">
                    <li v-for="empresa in item.empresa" :key="empresa.id">
                      {{ empresa.nome }}
                    </li>
                  </ul>
                </p>
                <p class="card-table-item">
                  <strong>Funções:</strong>
                  <ul class="scrollable-list">
                    <li v-for="funcao in item.funcao" :key="funcao.id">
                      {{ funcao.nome }}
                    </li>
                  </ul>
                </p>
                <p class="card-table-item">
                  <strong>Status:</strong>
                  {{ item.status }}
                </p>

                <button
                  type="button"
                  class="btn btn-modal"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="editar_usuario(item)"
                >
                  <span>Editar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="d-none d-lg-block">
        <table class="table rf_texto" v-if="!isLoading">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Email</th>
              <th scope="col">Empresas</th>
              <th scope="col">Funções</th>
              <th scope="col">Status</th>
              <th scope="col">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in usuarios" :key="item.id" class="table-linha">
              <td>{{ item.nome }}</td>
              <td>{{ item.email }}</td>
              <td>
                <ul class="scrollable-list">
                  <li v-for="empresa in item.empresa" :key="empresa.id">
                    {{ empresa.nome }}
                  </li>
                </ul>
              </td>
              <td>
                <ul class="scrollable-list">
                  <li v-for="funcao in item.funcao" :key="funcao.id">
                    {{ funcao.nome }}
                  </li>
                </ul>
              </td>
              <td>{{ item.status }}</td>
              <!-- <td v-for="funcao in item.funcoes[item.id]" :key="funcao.id">{{ funcao.nome }}</td>  -->
              <td>
                <button
                  type="button"
                  class="dropdown-toggle-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  @click="editar_usuario(item)"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="loading-indicator">Carregando...</div>
      </div>
      <pagination
        v-if="usuarios.length"
        :total="totalItems"
        :limit="pageSize"
        :offset="currentPage"
        :totalPages="Math.ceil(totalItems / pageSize)"
        @change-page="handlePageChange"
      />
    </div>
  </div>

  <!-- Modal para edição -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content card-container">
        <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
              <span class="txt-title-modal">Editar Usuário</span>
          <button
            class="btn-close"
            type="button"
            data-bs-toggle="modal"
            aria-label="Close"
          >
          </button>
        </div>
        <div class="modal-body txt-body-modal">
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-1 col-xl-1">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  id="edit_id"
                  v-model="edit_id"
                  disabled="true"
                />
                <label>Id</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="edit_status"
                  required
                >
                  <option value="0">Desabilitado</option>
                  <option value="1">Habilitado</option>
                </select>
                <label for="valid_status">Status</label>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  v-model="editPrincipal_empresa"
                  class="form-select txt-form-input"
                >
                  <option
                    v-for="option in empresas"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.nome }}
                  </option>
                </select>
                <label>Empresa Principal</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="edit_tipo_vendedor"
                  required
                >
                  <option value="1">Novo</option>
                  <option value="2">Usado</option>
                  <option value="3">Ambos</option>
                </select>
                <label for="valid_status">Tipo Vendedor</label>
              </div>
            </div>
          </div>
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  id="edit_username"
                  v-model="edit_username"
                />
                <label>Nome</label>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="email"
                  class="form-control txt-form-input"
                  id="edit_email"
                  v-model="edit_email"
                />
                <label>Email</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="password"
                  class="form-control txt-form-input"
                  v-model="edit_password"
                />
                <label>Senha</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
              <div class="form-floating txt-form-label">
                <input
                  type="password"
                  class="form-control"
                  v-model="edit_confirmPassword"
                />
                <label>Confirmar Senha</label>
              </div>
            </div>
          </div>
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label class="txt-form-label" >Empresa</label>
              <div class="form-floating ">
                <select
                  v-model="edit_empresa"
                  multiple
                  class="form-select txt-form-input"
                  size="5"
                  style="height: 8.7rem !important"
                  :disabled="edit_funcao.includes(6)"
                >
                  <option
                    v-for="option in empresas"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.nome }}
                  </option>
                </select>

              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              <label class="txt-form-label">Função</label>
              <div class="form-floating txt-form-label">
                <select
                  v-model="edit_funcao"
                  multiple
                  class="form-select txt-form-input"
                  size="5"
                  style="height: 8.7rem !important"
                >
                  <option
                    v-for="option in funcoes"
                    :value="option.id"
                    :key="option.id"
                  >
                    {{ option.descricao }}
                  </option>
                </select>

              </div>
            </div>
          </div>
        </div>
         <div class="modal-footer">
          <div class="d-md-none">
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn round-btn"
                  data-bs-dismiss="modal"
                >
                  <i class="bi bi-x-circle" title="Cancelar"></i>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn round-btn"
                  @click="update()"
                  data-bs-dismiss="modal"
                >
                  <i class="bi bi-check-circle" title="Confirmar"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="d-none d-md-block">
            <div class="row">
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-modal"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-6">
                <button
                  type="button"
                  class="btn btn-modal"
                  data-bs-dismiss="modal"
                  @click="update()"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Button trigger modal -->

  <RodapeVue />
</div>
</template>
<script>
import Sidebar from "../../components/menu/Sidebar.vue";
import axios from "axios";
import DataService from "../../services/DataService";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";

export default {
  name: "Usuários",
  components: {
    Sidebar,
    Navgator,
    Pagination,
    Message,
    RodapeVue,
  },
  data() {
    return {
      isLoading: false,
      usuarios: [],
      funcoes: [],
      empresas: [],

      modalAberto: false,
      tipo_vendedor: '',

      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,
      //Campos Cadastro
      user_id: "",
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      empresa_arr: [],
      empresa: "",
      funcao: [],
      status: "",
      btn_cadastrar: false,
      hab_empresa: true,

      /// Campos Modal Editar
      edit_id: "",
      edit_username: "",
      edit_email: "",
      edit_password: "",
      edit_confirmPassword: "",
      editPrincipal_empresa: "",
      edit_empresa: [],
      edit_funcao: [],
      edit_status: 1,
      edit_tipo_vendedor: "",
      edit_status_vendedor: 1,
      show1: false,
      //Params
      searchTitle: "",
      searchEmail: "",
      searchStatus: "",
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [5, 10, 15, 35, 50, 100],
      pageSize: 10,

      OpenClose: this.visible,
      currentPage:1,
    };
  },
  mounted() {
    this.retrieveUsuario();
    this.retrieveFuncoes();
    this.retrieveEmpresa();
  },

  methods: {
    abrirModal(funcao) {
      console.log(funcao);
      if (funcao.nome == 'Vendedor de Veículos') {
        this.modalAberto = true;
      } else {
        this.modalAberto = false;
        this.tipo_vendedor = null;
      }
    },
    async onSubmit() {
      const token = this.$store.state.auth.user.accessToken;
      const id_userCad = this.$store.state.auth.user.id;
      const dados = {
        username: this.username,
        email: this.email,
        password: this.password,
        role: this.funcao,
        empresaPrincipal_id: this.empresa,
        empresa_id: this.empresa_arr,
        id_userCad: id_userCad,
        tipo_vendedor: this.tipo_vendedor,
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}auth/signup`,
        dados,
        {
          headers: {
            "x-access-token": token,
          },
        }
      );
      const resp = JSON.stringify(response.status);

      if (resp == 201) {
        this.abrir_modal = true;
        this.msg = response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000, location.reload());
      }
      if (resp == 409) {
        this.abrir_modal = true;
        this.msg = "Email já cadastrado";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      if (re.test(email) == true) {
        this.btn_cadastrar = false;
      } else {
        (this.btn_cadastrar = true), (this.abrir_modal = true);
        this.msg = "Digite um email válido, ex: email@email.com!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    checar_senha() {
      if (
        (this.password || this.confirmPassword) &&
        this.password !== this.confirmPassword
      ) {
        this.abrir_modal = true;
        this.msg = "As senhas digitadas não são iguais!";
        setTimeout(() => (this.abrir_modal = false), 4000);
      }
    },
    //Buscar dados no banco de dados
    getRequestParams(searchTitle, searchEmail, page, pageSize, searchStatus) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (searchEmail) {
        params["email"] = searchEmail;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchStatus) {
        params["status"] = searchStatus;
      }
      return params;
    },
    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveUsuario(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveUsuario();
    },
    async retrieveUsuario(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.searchEmail,
          page,
          this.pageSize,
          this.searchStatus
        );
        const response = await userService.getUsers(params);
          var dados = [];
          var status;
          //var empresa_principal_nome;
          //const empresa_principal_id;

          const { users, totalPages, totalItems } = response.data;
          this.totalPages = totalPages;
          this.totalItems = totalItems;

          console.log("Dados do usuário", response.data)

          for (var i = 0; i < users.length; i++) {
            if (users[i].status == 0) {
              status = "Desabilitado";
            } else {
              status = "Habilitado";
            }
            // if(users[i].empresa_id === users[i].empresas.id){
            //   empresa_principal = users[i].empresas.nome
            // }

            const dados2 = {
              id: users[i].id,
              nome: users[i].username,
              email: users[i].email,
              empresa: users[i].empresas,
              funcao: users[i].funcoes,
              tipo_vend:users[i].tipo_vend,
              status: status,
              empresa_principal: users[i].empresa_id
            };
            dados.push(dados2);
          }

          this.usuarios = dados;
          console.log(this.usuarios)

          return true; // Indica sucesso
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },
    async retrieveFuncoes() {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        DataService.getFuncoes(params).then((response) => {
          const { funcoes, totalPages } = response.data;
          this.funcoes = funcoes;
          this.totalPages = totalPages;
          console.log("funções",response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    async retrieveEmpresa() {
      try {
        DataService.getEmpresas().then((response) => {
          this.empresas = response.data;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    editar_usuario(item) {
      console.log("Dados para editar usuario", item);
      this.edit_id = item.id;
      this.edit_username = item.nome;
      this.edit_email = item.email;
      this.editPrincipal_empresa = item.empresa_principal;
      this.edit_funcao = [];
      this.edit_empresa = [];
     this.edit_tipo_vendedor = item.tipo_vend && item.tipo_vend[0]
    ? item.tipo_vend[0].tipo_vendedor
    : null; // ou valor padrão (ex: 0, undefined, '')
      for (var i = 0; i < item.funcao.length; i++) {
        this.edit_funcao.push(item.funcao[i]["id"]);
      }
      for (var a = 0; a < item.empresa.length; a++) {
        this.edit_empresa.push(item.empresa[a]["id"]);
      }
    },
    async update() {
      if (
        (this.edit_password || this.edit_confirmPassword) &&
        this.edit_password !== this.edit_confirmPassword
      ) {
        return console.log("Os campos de senha não são iguais!");
      }

      const token = this.$store.state.auth.user.accessToken;
      const id_userCad = this.$store.state.auth.user.id;
      const headers = {
        "x-access-token": token,
      };
      const dados = {
        id: this.edit_id,
        email: this.edit_email,
        username: this.edit_username,
        password: this.edit_password,
        empresa: this.edit_empresa,
        empresa_id: this.editPrincipal_empresa,
        role: this.edit_funcao,
        id_userCad: id_userCad,
        status: this.edit_status,
        tipo_vendedor: this.edit_tipo_vendedor,

      };

      console.log("Dados enviados",dados);

      const response = await axios.patch(
        `${process.env.VUE_APP_API_URL}users/${this.edit_id}`,
        dados,
        { headers }
      );
      const resp = JSON.stringify(response.status);
      if (resp == 201) {
        this.abrir_modal = true;
        this.msg = "Alteração realizada com sucesso!";
        setTimeout(() => (this.abrir_modal = false), 4000);
        location.reload();
      }
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
